import { render } from "./EmergencyContactEditModal.vue?vue&type=template&id=e0f2c654"
import script from "./EmergencyContactEditModal.vue?vue&type=script&lang=js"
export * from "./EmergencyContactEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__